import { render, staticRenderFns } from "./member_card.vue?vue&type=template&id=51c24b48&scoped=true"
import script from "./member_card.vue?vue&type=script&lang=js"
export * from "./member_card.vue?vue&type=script&lang=js"
import style0 from "./member_card.vue?vue&type=style&index=0&id=51c24b48&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c24b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c24b48')) {
      api.createRecord('51c24b48', component.options)
    } else {
      api.reload('51c24b48', component.options)
    }
    module.hot.accept("./member_card.vue?vue&type=template&id=51c24b48&scoped=true", function () {
      api.rerender('51c24b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/member_card.vue"
export default component.exports